import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { SharedModule } from '../shared';

import { AppLayoutComponent } from './app-layout.component';

@NgModule({
  declarations: [AppLayoutComponent],
  imports: [CommonModule, RouterModule, SharedModule],
})
export class AppLayoutModule {}
